import { certificationColor, checkExpirationDate } from '../../modules/common';
import { CertificationsType } from '../../types/UserTypes';
import Tag, { TagColorType } from '../tag/Tag';
import {
  CertificationsCard,
  CertificationsTitle,
  TagsWrapper,
} from './CertificationList.styles';

const types = ['ISO', 'CLASS', 'MAKER', 'FLAG'];

export interface CertificationListProps {
  certifications: CertificationsType[];
  activeOnly?: boolean;
  clickable?: boolean;
  useColors?: boolean;
}

const getColor = (
  cert: CertificationsType,
  useColors: boolean
): TagColorType => {
  let result;

  if (useColors) {
    if (cert.status === 'APPROVED' && checkExpirationDate(cert.expiration)) {
      result = certificationColor.CLOSE_TO_EXPIRING;
    } else {
      result = certificationColor[cert.status] as TagColorType;
    }
  } else {
    result = 'black';
  }

  return result;
};

const CertificationList = ({
  certifications,
  activeOnly = false,
  clickable = false,
  useColors = true,
}: CertificationListProps): JSX.Element => {
  return (
    <>
      {types.map((type) => (
        <CertificationsCard statusColor="black" key={type}>
          <CertificationsTitle>{type}</CertificationsTitle>
          <TagsWrapper>
            {certifications
              ?.filter(
                (cert) =>
                  cert.type === type &&
                  (!activeOnly ||
                    (cert.status !== 'EXPIRED' &&
                      cert.status !== 'REJECTED' &&
                      cert.status !== 'PENDING'))
              )
              .map((cert) => (
                <Tag
                  key={cert._id}
                  text={cert.title}
                  color={getColor(cert, useColors)}
                  tooltip={
                    cert.expiration
                      ? `${
                          clickable
                            ? `Click to open the certification document.`
                            : ''
                        }<br/>Expiration date: ${new Date(
                          parseInt(cert.expiration, 10)
                        ).toLocaleDateString()}`
                      : ''
                  }
                  onClick={
                    clickable ? () => window.open(cert.file, '_blank') : null
                  }
                />
              ))}
          </TagsWrapper>
        </CertificationsCard>
      ))}
    </>
  );
};

export default CertificationList;
